export default function showMessage (text) {
    try {
        window.toast.custom(text)
    } catch (e) {
        window.alert(text);
        console.error(e);
    }
}